/* eslint-disable */
import agent from "../shared/agent";
import statusPedido from "../shared/statusPedido";
import { action, makeAutoObservable } from "mobx";
import { isEntregadorDisponivel } from "../shared/entregadorUtils";

// Função auxiliar para verificar se entregador deve aparecer no mapa
function shouldShowEntregador(entregador) {
  if (!entregador || entregador.ativo !== 1 || !entregador.lat || !entregador.lng) {
    return false;
  }

  const dataGeo = entregador.dataUltimaGeoLocalizacao;
  if (!dataGeo || dataGeo.length !== 14) {
    return false;
  }

  // Parse da string: "20251022110818" -> YYYY MM DD HH mm ss
  const year = parseInt(dataGeo.substr(0, 4));
  const month = parseInt(dataGeo.substr(4, 2)) - 1;
  const day = parseInt(dataGeo.substr(6, 2));
  const hour = parseInt(dataGeo.substr(8, 2));
  const minute = parseInt(dataGeo.substr(10, 2));
  const second = parseInt(dataGeo.substr(12, 2));

  const dataGeolocalizacao = new Date(year, month, day, hour, minute, second);
  const agora = new Date();
  const diferencaMs = agora - dataGeolocalizacao;
  const diferencaHoras = diferencaMs / (1000 * 60 * 60);

  return diferencaHoras <= 2;
}
class MapaStore {
  inProgress = false;

  updateMap = false;

  error = "";

  filtro = "";

  origemRestaurante = {
    lat: -23.31028,
    lng: -51.16278
  };

  pedidosMapa = [];

  pedidosPendentes = [];

  pedidosACaminho = [];

  pedidosFinalizados = [];

  pedidosCancelados = [];

  pedidosSelecionados = [[], [], [], [], []];

  pedidosHistorico = [];

  pedidosOrdenadosRota = [];

  entregadores = [];

  // Adapter de mapa (HERE ou Leaflet). Veja src/map e config/mapProvider.js
  mapAdapter = null;

  // Modo de distribuição da empresa (Empresa.ModoDistribuicao).
  // 1 = flexível (feature de Rotas, padrão do app Flutter). 0/ausente =
  // restritivo (comportamento clássico). Vem do login/checarSessao; NÃO é
  // resetado no rebuildStore. Só o valor EXATO 1 ativa a feature de rotas.
  modoDistribuicao = 0;

  tabIndex = 0;

  ordemDoFiltro = false;

  linkRota = "";

  originMarkerNeedsReset = false;

  constructor() {
    makeAutoObservable(this);
  }

  // Limpa a polyline de rota desenhada no mapa (não confundir com o getter
  // `rotas`, que são os grupos de pedidos aguardando motoca do modo flexível).
  resetRotas() {
    if (this.mapAdapter) this.mapAdapter.clearRoutes();
  }

  resetPedidos() {
    this.pedidosMapa = [];
    this.pedidosPendentes = [];
    this.pedidosACaminho = [];
    this.pedidosFinalizados = [];
    this.pedidosCancelados = [];
  }

  setError(error) {
    this.error = error;
  }

  setFiltro(filtro) {
    this.filtro = filtro;
  }

  setOrigem(lat, lng) {
    this.origemRestaurante = { lat: lat, lng: lng };
  }

  resetPedidosOrdenadosRota() {
    this.pedidosOrdenadosRota = [];
  }

  setPedidosOrdenadosRota(lista) {
    this.resetPedidosOrdenadosRota();
    this.pedidosOrdenadosRota = lista;

    if (lista.length > 0) {
      let rota = "";
      rota += "https://www.google.com/maps/dir/" + this.origemRestaurante.lat + "," + this.origemRestaurante.lng + "/";

      for (let i = 0; i < this.pedidosOrdenadosRota.length; i++) {
        rota += this.pedidosOrdenadosRota[i].lat + ',' + this.pedidosOrdenadosRota[i].lng;
        if (i < this.pedidosOrdenadosRota.length) rota += "/";
      }

      this.setLinkRota(rota);
    }
  }

  setLinkRota(link) {
    this.linkRota = link;
  }

  addPedidoPendente(pedido) {
    this.pedidosPendentes.push(pedido);
  }

  addPedidoFinalizado(pedido) {
    this.pedidosFinalizados.push(pedido);
  }

  addPedidoCancelado(pedido) {
    this.pedidosCancelados.push(pedido);
  }

  addPedidoACaminho(pedido) {
    this.pedidosACaminho.push(pedido);
  }

  removePedidoPendente(pedido) {
    const index = this.pedidosPendentes.indexOf(pedido);
    if (index > -1) {
      this.pedidosPendentes.splice(index, 1);
    }
  }

  setMapAdapter(adapter) {
    this.mapAdapter = adapter;
  }

  // Remove marcadores de pedidos e origem, preservando os de entregadores.
  clearPedidoMarkers() {
    if (this.mapAdapter) {
      this.mapAdapter.removeMarkersWhere(
        (key) => !String(key).startsWith("entregador_")
      );
    }
  }

  setTabIndex(tabIndex) {
    this.tabIndex = tabIndex;

    // Remove marcadores de pedidos e rotas, preserva marcadores de entregadores
    this.clearPedidoMarkers();
    this.resetRotas();

    if (this.distribuicaoFlexivel) {
      // Modo flexível: 0 Pendentes | 1 Rotas | 2 A Caminho | 3 Entregues | 4 Cancelados.
      // Na aba Rotas o mapa continua mostrando os pendentes (filtrados).
      this._atualizarPedidosMapaFlex();
    } else {
      // Modo restritivo (padrão): comportamento clássico, INTOCADO.
      switch (this.tabIndex) {
        case 0:
          this.pedidosMapa = [];
          this.pedidosMapa = this.pedidosPendentes;
          break;

        case 1:
          this.pedidosMapa = [];
          this.pedidosMapa = this.pedidosACaminho;
          break;

        case 2:
          this.pedidosMapa = [];
          this.pedidosMapa = this.pedidosFinalizados;
          break;

        case 3:
          this.pedidosMapa = [];
          this.pedidosMapa = this.pedidosCancelados;
          break;

        default:
          this.pedidosMapa = [];
          this.pedidosMapa = this.pedidosPendentes;
          break;
      }
    }

    // Notifica o mapa.js que o originMarker precisa ser resetado
    this.originMarkerNeedsReset = true;
    this.updateMap = true;
  }

  makeRoute() {
    if (this.pedidosSelecionados[0] && this.mapAdapter) {
      const via = [];
      for (var i = 0; i < this.pedidosSelecionados[0].length; i++) {
        via.push(this.pedidosSelecionados[0][i].lat + ',' + this.pedidosSelecionados[0][i].lng);
      }

      const origin = this.origemRestaurante.lat + ',' + this.origemRestaurante.lng;

      // origem == destino (rota de ida e volta passando por todos os pedidos)
      this.mapAdapter.showRoute({ origin, destination: origin, via });
    }
    this.updateMap = true;

    return true;
  }

  toggleSelected(pedido) {
    if (this.distribuicaoFlexivel) return this._toggleSelectedFlex(pedido);

    if (!pedido.selected) {
      this.pedidosSelecionados[this.tabIndex].push(pedido);
    } else {
      const index = this.pedidosSelecionados[this.tabIndex].indexOf(pedido);
      if (index > -1) {
        this.pedidosSelecionados[this.tabIndex].splice(index, 1);
      }
    }

    this.pedidosMapa = [];

    let index;
    // Modo restritivo (padrão): comportamento clássico, INTOCADO.
    switch (this.tabIndex) {
      case 0:
        index = this.pedidosPendentes.indexOf(pedido);
        if (index > -1) {
          this.pedidosPendentes[index].selected = !this.pedidosPendentes[index].selected;
        }

        this.pedidosMapa = this.pedidosPendentes;
        break;

      case 1:
        index = this.pedidosACaminho.indexOf(pedido);
        if (index > -1) {
          this.pedidosACaminho[index].selected = !this.pedidosACaminho[index].selected;
        }

        this.pedidosMapa = this.pedidosACaminho;
        break;

      case 2:
        index = this.pedidosFinalizados.indexOf(pedido);
        if (index > -1) {
          this.pedidosFinalizados[index].selected = !this.pedidosFinalizados[index].selected;
        }

        this.pedidosMapa = this.pedidosFinalizados;
        break;

      case 3:
        index = this.pedidosCancelados.indexOf(pedido);
        if (index > -1) {
          this.pedidosCancelados[index].selected = !this.pedidosCancelados[index].selected;
        }

        this.pedidosMapa = this.pedidosCancelados;
        break;

      default:
        index = this.pedidosPendentes.indexOf(pedido);
        if (index > -1) {
          this.pedidosPendentes[index].selected = !this.pedidosPendentes[index].selected;
        }

        this.pedidosMapa = this.pedidosPendentes;
        break;
    }


    this.updateMap = true;
  }

  definirEntregadores(idEntregador) {
    let pedidos = [];
    this.inProgress = true;

    for (let i = 0; i < this.pedidosSelecionados[0].length; i++) {
      pedidos.push({
        "PedidoGuidId": this.pedidosSelecionados[0][i].guid,
        "EntregadorId": idEntregador
      })
    }

    if (pedidos.length > 0) {
      return agent.Pedidos.definirEntregadores(pedidos)
        .then((res) => {
          if (res.CodigoRetorno === 1) {
            this.setError("");

            this.pedidosSelecionados = [[], [], [], [], []];
            // Remove apenas marcadores de pedidos (preserva entregadores)
            this.clearPedidoMarkers();
            // Reset origin marker since it was removed
            this.originMarkerNeedsReset = true;
          } else {
            this.setError(res.Mensagem);
            throw res;
          }
        })
        .finally(
          action(() => {
            this.buscarPedidos(true); // Pass flag to force refresh
            this.inProgress = false;
          })
        );
    }
  }

  definirStatus(status, entregadorId = null) {
    let pedidos = [];
    this.inProgress = true;

    // Verifica se deve incluir EntregadorId
    let incluirEntregadorId = false;
    if (status === 2 && entregadorId) {
      // Busca o entregador na lista de entregadores
      const entregador = this.entregadores.find(e => e.id === entregadorId);

      // Usa função utilitária para verificar se está disponível (bolinha verde)
      if (isEntregadorDisponivel(entregador, this.pedidosPendentes, this.pedidosACaminho)) {
        incluirEntregadorId = true;
      }
    }

    for (let i = 0; i < this.pedidosSelecionados[this.tabIndex].length; i++) {
      const pedido = {
        "PedidoGuidId": this.pedidosSelecionados[this.tabIndex][i].guid,
        "Status": status,
        "Ordem": i+1
      };

      // Adiciona EntregadorId se todas as condições forem atendidas
      if (incluirEntregadorId) {
        pedido.EntregadorId = entregadorId;
      }

      pedidos.push(pedido);
    }

    if (pedidos.length > 0) {
      return agent.Pedidos.definirStatus(pedidos)
        .then((res) => {
          if (res.CodigoRetorno === 1) {
            this.setError("");

            this.pedidosSelecionados = [[], [], [], [], []];
            // Remove apenas marcadores de pedidos (preserva entregadores)
            this.clearPedidoMarkers();
            // Reset origin marker since it was removed
            this.originMarkerNeedsReset = true;
          } else {
            this.setError(res.Mensagem);
            throw res;
          }
        })
        .finally(
          action(() => {
            this.buscarPedidos();
            this.inProgress = false;
          })
        );
    }
  }

  buscarPedidosHistorico() {
    this.inProgress = true;
    let pedidosHistorico = [];
    let pedido;
    return agent.Pedidos.listarPedidosHistorico()
      .then((res) => {
        if (res.CodigoRetorno === 1) {
          this.setError("");
          for (let i = 0; i < res.Registros.length; i++) {

            pedido = {
              id: res.Registros[i].PedidoId,
              guid: res.Registros[i].PedidoGuidId,
              cliente: res.Registros[i].NomeCliente,
              status: statusPedido.statusPedido[res.Registros[i].Status],
              identificacao: res.Registros[i].Identificacao,
              subIdentificacao: res.Registros[i].SubIdentificacao,
              marketplaceId: res.Registros[i].MarketPlaceId,
              endereco: res.Registros[i].Logradouro + ', ' + res.Registros[i].NumeroLogradouro,
              complemento: res.Registros[i].Complemento,
              lat: res.Registros[i].Latitude,
              lng: res.Registros[i].Longitude,
              valor: res.Registros[i].ValorProdutos,
              valorTaxa: res.Registros[i].ValorTxEntrega,
              troco: res.Registros[i].ValorTrocoPara,
              selected: false,
              entregador: res.Registros[i].Entregador,
              sequenciaPdv: res.Registros[i].SequenciaPDV,
              rota: Number(res.Registros[i].Rota) || 0,
              ordem: Number(res.Registros[i].Ordem) || 0
            };


            pedidosHistorico.push(pedido);


          }
        } else {
          this.setError(res.Mensagem);
          throw res;
        }
      })
      .finally(
        action(() => {
          this.pedidosHistorico = pedidosHistorico;
          this.inProgress = false;
        })
      );
  }

  buscarPedidos(forceRefresh = false) {
    // Modo flexível: busca própria, porte fiel do rotas_controller.dart (Flutter).
    // O modo restritivo segue abaixo EXATAMENTE como era.
    if (this.distribuicaoFlexivel) return this._buscarPedidosFlex(forceRefresh);

    this.inProgress = true;
    let selecionado;
    let pedidosSelecionadosNovo = [[], [], [], [], []];
    let pedidosPendentesNovo = [];
    let pedidosACaminhoNovo = [];
    let pedidosFinalizadosNovo = [];
    let pedidosCanceladosNovo = [];
    let pedido;
    let usouFiltro = false;
    let entregadoresChanged = false;
    // Slots de seleção por grupo. No modo restritivo mantêm EXATAMENTE o esquema
    // clássico (aCaminho=1, finalizados=2, cancelados=1). No flexível mudam por
    // causa da aba Rotas.
    const slotACaminho = this.distribuicaoFlexivel ? 2 : 1;
    const slotFinalizados = this.distribuicaoFlexivel ? 3 : 2;
    const slotCancelados = this.distribuicaoFlexivel ? 4 : 1;
    return agent.Pedidos.listarPedidos()
      .then((res) => {
        if (res.CodigoRetorno === 1) {
          this.setError("");

          if (res.Entregadores && res.Entregadores.length > 0) {
            const newEntregadores = res.Entregadores.map(entregador => ({
              id: entregador.EntregadorId,
              guid: entregador.EntregadorGuidId,
              nome: entregador.Nome,
              nomeResumido: entregador.NomeResumido,
              celular: entregador.Celular,
              codigoExterno: entregador.CodigoExternoEntregador,
              lat: entregador.Latitude,
              lng: entregador.Longitude,
              dataUltimaGeoLocalizacao: entregador.DataUltimaGeoLocalizacao,
              status: entregador.Status,
              ativo: entregador.Ativo,
              cor: entregador.Cor || '',
              horarioMudancaStatus: entregador.HorarioMudancaStatus
            }));

            // OTIMIZAÇÃO: Só verifica mudanças em entregadores que devem aparecer no mapa
            // Isso evita processar 100+ entregadores offline desnecessariamente
            const oldVisibleEntregadores = this.entregadores.filter(e => shouldShowEntregador(e));
            const newVisibleEntregadores = newEntregadores.filter(e => shouldShowEntregador(e));

            // Se a quantidade de entregadores visíveis mudou, precisa atualizar
            if (oldVisibleEntregadores.length !== newVisibleEntregadores.length) {
              entregadoresChanged = true;
            } else {
              // Verifica se algum entregador visível mudou de posição ou propriedades
              for (let i = 0; i < newVisibleEntregadores.length; i++) {
                const newEnt = newVisibleEntregadores[i];
                const oldEnt = oldVisibleEntregadores.find(e => e.id === newEnt.id);

                if (!oldEnt ||
                    oldEnt.lat !== newEnt.lat ||
                    oldEnt.lng !== newEnt.lng ||
                    oldEnt.cor !== newEnt.cor) {
                  entregadoresChanged = true;
                  break;
                }
              }
            }

            this.entregadores = newEntregadores;
          }

          // Verifica se existe exact match no SequenciaPDV antes do loop
          var temExactMatch = false;
          if (this.filtro != '') {
            for (let j = 0; j < res.Registros.length; j++) {
              if (res.Registros[j].SequenciaPDV.toString() === this.filtro) {
                temExactMatch = true;
                break;
              }
            }
          }

          for (let i = 0; i < res.Registros.length; i++) {

            if (this.filtro != '') {
              usouFiltro = true;

              var filtroNormalizado = this.filtro.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              var naoPular = false;
              let existeSequenciaPDV = false;

              this.pedidosSelecionados.forEach(pedidoArray => {
                if (pedidoArray.some(item => item['id'] === res.Registros[i].PedidoId)) {
                  existeSequenciaPDV = true;
                }
              });

              if (temExactMatch) {
                // Exact match encontrado: mostra apenas o pedido com SequenciaPDV exato
                if ((res.Registros[i].SequenciaPDV.toString() === this.filtro) ||
                  (existeSequenciaPDV)) {
                  naoPular = true;
                }
              } else {
                // Sem exact match: usa filtro geral
                if ((res.Registros[i].NomeCliente.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")).includes(filtroNormalizado) ||
                  (res.Registros[i].Identificacao.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")).includes(filtroNormalizado) ||
                  (res.Registros[i].Logradouro.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")).includes(filtroNormalizado) ||
                  (res.Registros[i].SubIdentificacao !== "" && res.Registros[i].SubIdentificacao.toString().includes(this.filtro)) ||
                  (res.Registros[i].SequenciaPDV.toString()).includes(this.filtro) ||
                  (existeSequenciaPDV)) {
                  naoPular = true;
                }
              }

              if (naoPular == false) {
                continue;
              }
            } else if (this.ordemDoFiltro) {
              usouFiltro = true;
              this.ordemDoFiltro = false;
            }
            selecionado = false;
            switch (res.Registros[i].Status) {
              case 0:
              case 1:
                if (this.pedidosSelecionados[0].some(e => e.id === res.Registros[i].PedidoId)) {
                  selecionado = true;
                }

                pedido = {
                  id: res.Registros[i].PedidoId,
                  guid: res.Registros[i].PedidoGuidId,
                  cliente: res.Registros[i].NomeCliente,
                  status: statusPedido.statusPedido[res.Registros[i].Status],
                  identificacao: res.Registros[i].Identificacao,
                  // subIdentificacao: i == 0 ? '1234' : res.Registros[i].SubIdentificacao,
                  // marketplaceId: i  == 0 ? 4 : i == 1 ? 1 :  i == 2 ? 6 : res.Registros[i].MarketPlaceId,
                  subIdentificacao: res.Registros[i].SubIdentificacao,
                  marketplaceId: res.Registros[i].MarketPlaceId,
                  endereco: res.Registros[i].Logradouro + ', ' + res.Registros[i].NumeroLogradouro,
                  complemento: res.Registros[i].Complemento,
                  lat: res.Registros[i].Latitude,
                  lng: res.Registros[i].Longitude,
                  valor: res.Registros[i].ValorProdutos,
                  valorTaxa: res.Registros[i].ValorTxEntrega,
                  troco: res.Registros[i].ValorTrocoPara,
                  selected: selecionado,
                  entregador: res.Registros[i].Entregador,
                  sequenciaPdv: res.Registros[i].SequenciaPDV,
                  rota: Number(res.Registros[i].Rota) || 0,
                  ordem: Number(res.Registros[i].Ordem) || 0,
                  dataPedido: res.Registros[i].DataPedido,
                  dataDespacho: res.Registros[i].DataDespacho,
                  dataFinalizacao: res.Registros[i].DataFinalizacao
                };

                if (selecionado == true) pedidosSelecionadosNovo[0].push(pedido);

                pedidosPendentesNovo.push(pedido);
                // this.addPedidoPendente(pedido);
                break;

              case 2:
                //case 3:
                //case 4:
                if (this.pedidosSelecionados[slotACaminho].some(e => e.id === res.Registros[i].PedidoId)) {
                  selecionado = true;
                }

                pedido = {
                  id: res.Registros[i].PedidoId,
                  guid: res.Registros[i].PedidoGuidId,
                  cliente: res.Registros[i].NomeCliente,
                  status: statusPedido.statusPedido[res.Registros[i].Status],
                  identificacao: res.Registros[i].Identificacao,
                  subIdentificacao: res.Registros[i].SubIdentificacao,
                  marketplaceId: res.Registros[i].MarketPlaceId,
                  endereco: res.Registros[i].Logradouro + ', ' + res.Registros[i].NumeroLogradouro,
                  complemento: res.Registros[i].Complemento,
                  lat: res.Registros[i].Latitude,
                  lng: res.Registros[i].Longitude,
                  valor: res.Registros[i].ValorProdutos,
                  valorTaxa: res.Registros[i].ValorTxEntrega,
                  troco: res.Registros[i].ValorTrocoPara,
                  selected: selecionado,
                  entregador: res.Registros[i].Entregador,
                  sequenciaPdv: res.Registros[i].SequenciaPDV,
                  rota: Number(res.Registros[i].Rota) || 0,
                  ordem: Number(res.Registros[i].Ordem) || 0,
                  dataPedido: res.Registros[i].DataPedido,
                  dataDespacho: res.Registros[i].DataDespacho,
                  dataFinalizacao: res.Registros[i].DataFinalizacao
                };

                if (selecionado == true) pedidosSelecionadosNovo[slotACaminho].push(pedido);

                pedidosACaminhoNovo.push(pedido);
                //this.addPedidoACaminho(pedido);
                break;

              case 9:
                if (this.pedidosSelecionados[slotCancelados].some(e => e.id === res.Registros[i].PedidoId)) {
                  selecionado = true;
                }

                pedido = {
                  id: res.Registros[i].PedidoId,
                  guid: res.Registros[i].PedidoGuidId,
                  cliente: res.Registros[i].NomeCliente,
                  status: statusPedido.statusPedido[res.Registros[i].Status],
                  identificacao: res.Registros[i].Identificacao,
                  subIdentificacao: res.Registros[i].SubIdentificacao,
                  marketplaceId: res.Registros[i].MarketPlaceId,
                  endereco: res.Registros[i].Logradouro + ', ' + res.Registros[i].NumeroLogradouro,
                  complemento: res.Registros[i].Complemento,
                  lat: res.Registros[i].Latitude,
                  lng: res.Registros[i].Longitude,
                  valor: res.Registros[i].ValorProdutos,
                  valorTaxa: res.Registros[i].ValorTxEntrega,
                  troco: res.Registros[i].ValorTrocoPara,
                  selected: selecionado,
                  entregador: res.Registros[i].Entregador,
                  sequenciaPdv: res.Registros[i].SequenciaPDV,
                  rota: Number(res.Registros[i].Rota) || 0,
                  ordem: Number(res.Registros[i].Ordem) || 0,
                  dataPedido: res.Registros[i].DataPedido,
                  dataDespacho: res.Registros[i].DataDespacho,
                  dataFinalizacao: res.Registros[i].DataFinalizacao
                };

                if (selecionado == true) pedidosSelecionadosNovo[slotCancelados].push(pedido);

                pedidosCanceladosNovo.push(pedido);
                break;

              default:
                if (this.pedidosSelecionados[slotFinalizados].some(e => e.id === res.Registros[i].PedidoId)) {
                  selecionado = true;
                }

                pedido = {
                  id: res.Registros[i].PedidoId,
                  guid: res.Registros[i].PedidoGuidId,
                  cliente: res.Registros[i].NomeCliente,
                  status: statusPedido.statusPedido[res.Registros[i].Status],
                  identificacao: res.Registros[i].Identificacao,
                  subIdentificacao: res.Registros[i].SubIdentificacao,
                  marketplaceId: res.Registros[i].MarketPlaceId,
                  endereco: res.Registros[i].Logradouro + ', ' + res.Registros[i].NumeroLogradouro,
                  complemento: res.Registros[i].Complemento,
                  lat: res.Registros[i].Latitude,
                  lng: res.Registros[i].Longitude,
                  valor: res.Registros[i].ValorProdutos,
                  valorTaxa: res.Registros[i].ValorTxEntrega,
                  troco: res.Registros[i].ValorTrocoPara,
                  selected: selecionado,
                  entregador: res.Registros[i].Entregador,
                  sequenciaPdv: res.Registros[i].SequenciaPDV,
                  rota: Number(res.Registros[i].Rota) || 0,
                  ordem: Number(res.Registros[i].Ordem) || 0,
                  dataPedido: res.Registros[i].DataPedido,
                  dataDespacho: res.Registros[i].DataDespacho,
                  dataFinalizacao: res.Registros[i].DataFinalizacao
                };

                if (selecionado == true) pedidosSelecionadosNovo[slotFinalizados].push(pedido);

                pedidosFinalizadosNovo.push(pedido);
                //this.addPedidoFinalizado(pedido);
                break;
            }
          }

          // Ordena todas as listas por sequenciaPdv (apenas se não houver filtro numérico ativo)
          if (!(this.filtro != '' && /^\d+$/.test(this.filtro))) {
            pedidosPendentesNovo.sort((a, b) => (a.sequenciaPdv || 0) - (b.sequenciaPdv || 0));
            pedidosACaminhoNovo.sort((a, b) => (a.sequenciaPdv || 0) - (b.sequenciaPdv || 0));
            pedidosFinalizadosNovo.sort((a, b) => (a.sequenciaPdv || 0) - (b.sequenciaPdv || 0));
            pedidosCanceladosNovo.sort((a, b) => (a.sequenciaPdv || 0) - (b.sequenciaPdv || 0));
          }

          if (usouFiltro) {
            // Remove marcadores de pedidos e rotas, preserva marcadores de entregadores
            this.clearPedidoMarkers();
            this.resetRotas();
          }
        } else {
          this.setError(res.Mensagem);
          throw res;
        }
      })
      .finally(
        action(() => {
          const pedidosChanged = !(this.pedidosPendentes.length === pedidosPendentesNovo.length &&
            this.pedidosACaminho.length === pedidosACaminhoNovo.length &&
            this.pedidosFinalizados.length === pedidosFinalizadosNovo.length &&
            this.pedidosCancelados.length === pedidosCanceladosNovo.length);

          if (pedidosChanged || usouFiltro || forceRefresh) {
            this.pedidosSelecionados = pedidosSelecionadosNovo;
            this.pedidosPendentes = pedidosPendentesNovo;
            this.pedidosACaminho = pedidosACaminhoNovo;
            this.pedidosFinalizados = pedidosFinalizadosNovo;
            this.pedidosCancelados = pedidosCanceladosNovo;


            this.inProgress = false;
            switch (this.tabIndex) {
              case 0:
                this.pedidosMapa = [];

                if (this.filtro != '' && /^\d+$/.test(this.filtro)) {
                  var indexPedido = -1;

                  if (this.filtro.length === 4) {
                    indexPedido = this.pedidosPendentes.findIndex(p => p.subIdentificacao?.toString() === this.filtro);
                  }

                  if (indexPedido === -1) {
                    indexPedido = this.pedidosPendentes.findIndex(p => p.sequenciaPdv?.toString() === this.filtro);
                  }

                  if (indexPedido > 0) {
                    this.pedidosPendentes.unshift(this.pedidosPendentes.splice(indexPedido, 1)[0]);
                    this.ordemDoFiltro = true;
                  }
                }

                this.pedidosMapa = this.pedidosPendentes;
                break;

              case 1:
                this.pedidosMapa = [];

                if (this.filtro != '' && /^\d+$/.test(this.filtro)) {
                  var indexPedido = -1;

                  if (this.filtro.length === 4) {
                    indexPedido = this.pedidosACaminho.findIndex(p => p.subIdentificacao?.toString() === this.filtro);
                  }

                  if (indexPedido === -1) {
                    indexPedido = this.pedidosACaminho.findIndex(p => p.sequenciaPdv?.toString() === this.filtro);
                  }


                  if (indexPedido > 0) {
                    this.pedidosACaminho.unshift(this.pedidosACaminho.splice(indexPedido, 1)[0]);
                    this.ordemDoFiltro = true;
                  }
                }

                this.pedidosMapa = this.pedidosACaminho;
                break;

              case 2:
                this.pedidosMapa = [];

                if (this.filtro != '' && /^\d+$/.test(this.filtro)) {
                  var indexPedido = -1;

                  if (this.filtro.length === 4) {
                    indexPedido = this.pedidosFinalizados.findIndex(p => p.subIdentificacao?.toString() === this.filtro);
                  }

                  if (indexPedido === -1) {
                    indexPedido = this.pedidosFinalizados.findIndex(p => p.sequenciaPdv?.toString() === this.filtro);
                  }


                  if (indexPedido > 0) {
                    this.pedidosFinalizados.unshift(this.pedidosFinalizados.splice(indexPedido, 1)[0]);
                    this.ordemDoFiltro = true;
                  }
                }

                this.pedidosMapa = this.pedidosFinalizados;
                break;

              case 3:
                this.pedidosMapa = [];

                if (this.filtro != '' && /^\d+$/.test(this.filtro)) {
                  var indexPedido = -1;

                  if (this.filtro.length === 4) {
                    indexPedido = this.pedidosCancelados.findIndex(p => p.subIdentificacao?.toString() === this.filtro);
                  }

                  if (indexPedido === -1) {
                    indexPedido = this.pedidosCancelados.findIndex(p => p.sequenciaPdv?.toString() === this.filtro);
                  }


                  if (indexPedido > 0) {
                    this.pedidosCancelados.unshift(this.pedidosCancelados.splice(indexPedido, 1)[0]);
                    this.ordemDoFiltro = true;
                  }
                }

                this.pedidosMapa = this.pedidosCancelados;
                break;

              default:
                this.pedidosMapa = [];

                if (this.filtro != '' && /^\d+$/.test(this.filtro)) {
                  var indexPedido = -1;

                  if (this.filtro.length === 4) {
                    indexPedido = this.pedidosPendentes.findIndex(p => p.subIdentificacao?.toString() === this.filtro);
                  }

                  if (indexPedido === -1) {
                    indexPedido = this.pedidosPendentes.findIndex(p => p.sequenciaPdv?.toString() === this.filtro);
                  }


                  if (indexPedido > 0) {
                    this.pedidosPendentes.unshift(this.pedidosPendentes.splice(indexPedido, 1)[0]);
                    this.ordemDoFiltro = true;
                  }
                }

                this.pedidosMapa = this.pedidosPendentes;
                break;
            }
            this.updateMap = true;
          }

          // Also trigger map update if only entregadores changed (even when pedidos didn't)
          if (entregadoresChanged && !pedidosChanged) {
            this.updateMap = true;
          }

        })
      );
  }


  // ----------------- Modo de distribuição -----------------

  setModoDistribuicao(modo) {
    this.modoDistribuicao = Number(modo) || 0;
  }

  get distribuicaoFlexivel() {
    return this.modoDistribuicao === 1;
  }

  // ----------------- Rotas (aguardando motoca) -----------------

  // Pedidos pendentes que ainda NÃO estão em nenhuma rota (avulsos). É o que
  // a aba "Pendentes" mostra na lista.
  get pedidosAvulsos() {
    return this.pedidosPendentes.filter((p) => !p.rota);
  }

  // Rotas "aguardando motoca": pedidos pendentes (status 0/1) com `rota != 0`,
  // agrupados por número de rota e ordenados por `Ordem`. Ao despachar (status
  // 2) o pedido sai daqui e vai pra aba "A Caminho".
  get rotas() {
    const porRota = new Map();
    this.pedidosPendentes
      .filter((p) => p.rota)
      .forEach((p) => {
        if (!porRota.has(p.rota)) porRota.set(p.rota, []);
        porRota.get(p.rota).push(p);
      });

    const lista = Array.from(porRota.entries()).map(([numero, pedidos]) => {
      const ordenados = pedidos
        .slice()
        .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));

      // EntregadorId "da rota": o primeiro não-zero encontrado (0 = sem motoca).
      const comEntregador = ordenados.find(
        (p) => p.entregador && p.entregador.EntregadorId
      );
      const entregadorId = comEntregador
        ? comEntregador.entregador.EntregadorId
        : 0;
      const dados = entregadorId
        ? this.entregadores.find((e) => e.id === entregadorId)
        : null;

      return {
        numero,
        pedidos: ordenados,
        quantidade: ordenados.length,
        entregadorId,
        entregadorNome: dados ? dados.nome : "",
        entregadorCor: dados ? dados.cor : "",
        temEntregador: entregadorId !== 0,
      };
    });

    lista.sort((a, b) => a.numero - b.numero);
    return lista;
  }

  get qtdRotas() {
    return this.rotas.length;
  }

  // ----------------- Busca / filtro / seleção (modo flexível) -----------------
  // Porte do rotas_controller.dart. Diferenças em relação ao modo restritivo:
  // - as listas do store guardam TODOS os pedidos do grupo; o filtro só afeta o
  //   que é exibido (lista e mapa), nunca badges, rotas ou seleção;
  // - a seleção é por GRUPO (abas Pendentes e Rotas compartilham o slot 0) e
  //   mantém a ordem de clique entre refreshs (define Ordem/waypoints);
  // - se a resposta falhar, mantém o que já estava na tela.

  _mapPedidoFlex(r, selected) {
    return {
      id: r.PedidoId,
      guid: r.PedidoGuidId,
      cliente: r.NomeCliente,
      status: statusPedido.statusPedido[r.Status],
      identificacao: r.Identificacao,
      subIdentificacao: r.SubIdentificacao,
      marketplaceId: r.MarketPlaceId,
      endereco: r.Logradouro + ', ' + r.NumeroLogradouro,
      complemento: r.Complemento,
      lat: r.Latitude,
      lng: r.Longitude,
      valor: r.ValorProdutos,
      valorTaxa: r.ValorTxEntrega,
      troco: r.ValorTrocoPara,
      selected,
      entregador: r.Entregador,
      sequenciaPdv: r.SequenciaPDV,
      rota: Number(r.Rota) || 0,
      ordem: Number(r.Ordem) || 0,
      dataPedido: r.DataPedido,
      dataDespacho: r.DataDespacho,
      dataFinalizacao: r.DataFinalizacao,
    };
  }

  // Slot de seleção do grupo de um status (0 pendente | 2 aCaminho | 3 finalizado | 4 cancelado).
  _slotFlexDoStatus(status) {
    switch (status) {
      case 0:
      case 1: return 0;
      case 2: return 2;
      case 9: return 4;
      default: return 3;
    }
  }

  // Lista COMPLETA do grupo da aba atual (Rotas usa o grupo pendente, como no Flutter).
  _grupoDaAbaFlex(tab = this.tabIndex) {
    switch (tab) {
      case 2: return this.pedidosACaminho;
      case 3: return this.pedidosFinalizados;
      case 4: return this.pedidosCancelados;
      default: return this.pedidosPendentes;
    }
  }

  // Termos do filtro separados por vírgula ("23,53,22" -> ["23","53","22"]).
  get termosFiltroFlex() {
    return (this.filtro || '')
      .toLowerCase()
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t !== '');
  }

  // _aplicarTermo do Flutter: match EXATO de SequenciaPDV mostra só ele; senão
  // busca geral; filtro numérico joga o match (subId de 4 dígitos, senão seq)
  // pro topo.
  _aplicarTermoFlex(lista, f) {
    if (!f) return lista;
    const txt = (v) => (v == null ? '' : String(v)).toLowerCase();

    const exatos = lista.filter((p) => txt(p.sequenciaPdv) === f);
    if (exatos.length > 0) return exatos;

    const result = lista.filter((p) =>
      txt(p.cliente).includes(f) ||
      txt(p.identificacao).includes(f) ||
      txt(p.endereco).includes(f) ||
      txt(p.subIdentificacao).includes(f) ||
      txt(p.sequenciaPdv).includes(f));

    if (/^\d+$/.test(f)) {
      let idx = -1;
      if (f.length === 4) idx = result.findIndex((p) => txt(p.subIdentificacao) === f);
      if (idx === -1) idx = result.findIndex((p) => txt(p.sequenciaPdv) === f);
      if (idx > 0) result.unshift(result.splice(idx, 1)[0]);
    }
    return result;
  }

  // _aplicarFiltro do Flutter: vários termos são unidos NA ORDEM digitada, sem repetir.
  filtrarFlex(lista) {
    const termos = this.termosFiltroFlex;
    if (termos.length === 0) return lista;
    if (termos.length === 1) return this._aplicarTermoFlex(lista, termos[0]);
    const vistos = new Set();
    const result = [];
    termos.forEach((t) => {
      this._aplicarTermoFlex(lista, t).forEach((p) => {
        if (!vistos.has(p.id)) {
          vistos.add(p.id);
          result.push(p);
        }
      });
    });
    return result;
  }

  // Listas exibidas em cada aba (já filtradas). Pendentes = só os avulsos.
  get pedidosAvulsosVisiveis() {
    return this.filtrarFlex(this.pedidosPendentes).filter((p) => !p.rota);
  }

  get pedidosACaminhoVisiveis() {
    return this.filtrarFlex(this.pedidosACaminho);
  }

  get pedidosFinalizadosVisiveis() {
    return this.filtrarFlex(this.pedidosFinalizados);
  }

  get pedidosCanceladosVisiveis() {
    return this.filtrarFlex(this.pedidosCancelados);
  }

  // O mapa mostra o grupo da aba, filtrado (na aba Rotas: todos os pendentes).
  _atualizarPedidosMapaFlex() {
    this.pedidosMapa = [];
    this.pedidosMapa = this.filtrarFlex(this._grupoDaAbaFlex());
  }

  // selecionarPorEnter do Flutter: com vários termos, seleciona um por termo na
  // ordem digitada; senão, 1 resultado => seleciona; vários => o de seq. exata.
  selecionarPorEnterFlex() {
    const lista = this.filtrarFlex(this._grupoDaAbaFlex());
    const termos = this.termosFiltroFlex;
    if (termos.length > 1) {
      termos.forEach((t) => {
        const p = lista.find((x) => String(x.sequenciaPdv) === t);
        if (p && !p.selected) this.toggleSelected(p);
      });
      return;
    }
    const f = (this.filtro || '').trim();
    if (lista.length === 1 && !lista[0].selected) {
      this.toggleSelected(lista[0]);
    } else if (lista.length > 1 && f !== '') {
      const p = lista.find((x) => String(x.sequenciaPdv) === f);
      if (p && !p.selected) this.toggleSelected(p);
    }
  }

  _toggleSelectedFlex(pedido) {
    const grupos = [
      [0, this.pedidosPendentes],
      [2, this.pedidosACaminho],
      [3, this.pedidosFinalizados],
      [4, this.pedidosCancelados],
    ];
    const achado = grupos.find(([, lista]) => lista.some((p) => p.id === pedido.id));
    if (!achado) return;
    const [slot, lista] = achado;
    const alvo = lista.find((p) => p.id === pedido.id);
    const sel = this.pedidosSelecionados[slot];
    const i = sel.findIndex((p) => p.id === pedido.id);
    if (i > -1) {
      sel.splice(i, 1);
      alvo.selected = false;
    } else {
      sel.push(alvo);
      alvo.selected = true;
    }
    this._atualizarPedidosMapaFlex();
    this.updateMap = true;
  }

  _buscarPedidosFlex(forceRefresh = false) {
    this.inProgress = true;
    let entregadoresChanged = false;
    let novo = null;

    return agent.Pedidos.listarPedidos()
      .then((res) => {
        if (res.CodigoRetorno !== 1) {
          this.setError(res.Mensagem);
          throw res;
        }
        this.setError("");

        let entregadores = null;
        if (res.Entregadores && res.Entregadores.length > 0) {
          entregadores = res.Entregadores.map((e) => ({
            id: e.EntregadorId,
            guid: e.EntregadorGuidId,
            nome: e.Nome,
            nomeResumido: e.NomeResumido,
            celular: e.Celular,
            codigoExterno: e.CodigoExternoEntregador,
            lat: e.Latitude,
            lng: e.Longitude,
            dataUltimaGeoLocalizacao: e.DataUltimaGeoLocalizacao,
            status: e.Status,
            ativo: e.Ativo,
            cor: e.Cor || '',
            horarioMudancaStatus: e.HorarioMudancaStatus,
          }));
          const antes = this.entregadores.filter((e) => shouldShowEntregador(e));
          const depois = entregadores.filter((e) => shouldShowEntregador(e));
          entregadoresChanged = antes.length !== depois.length || depois.some((n) => {
            const o = antes.find((e) => e.id === n.id);
            return !o || o.lat !== n.lat || o.lng !== n.lng || o.cor !== n.cor;
          });
        }

        // Ids selecionados por slot, na ORDEM DE CLIQUE.
        const selIds = this.pedidosSelecionados.map((s) => (s || []).map((p) => p.id));
        const grupos = { 0: [], 2: [], 3: [], 4: [] };
        (res.Registros || []).forEach((r) => {
          const slot = this._slotFlexDoStatus(r.Status);
          grupos[slot].push(this._mapPedidoFlex(r, selIds[slot].includes(r.PedidoId)));
        });

        // Ordena por SequenciaPDV, exceto com filtro numérico ("23" ou "23,53,22").
        const filtroNum = /^\s*\d+(\s*,\s*\d+)*\s*$/.test(this.filtro || '');
        if (!((this.filtro || '') !== '' && filtroNum)) {
          Object.values(grupos).forEach((l) =>
            l.sort((a, b) => (a.sequenciaPdv || 0) - (b.sequenciaPdv || 0)));
        }

        // Seleção reconstruída com os objetos novos, preservando a ordem de clique.
        const selecionados = [[], [], [], [], []];
        [0, 2, 3, 4].forEach((slot) => {
          const porId = new Map(grupos[slot].map((p) => [p.id, p]));
          selecionados[slot] = selIds[slot].map((id) => porId.get(id)).filter(Boolean);
        });

        novo = { grupos, selecionados, entregadores };
      })
      .catch((e) => {
        // Igual ao Flutter: em erro, mantém os dados anteriores na tela.
        console.error('Erro ao buscar pedidos (modo flexível):', e);
      })
      .finally(
        action(() => {
          this.inProgress = false;
          if (!novo) return;

          if (novo.entregadores) this.entregadores = novo.entregadores;

          // Assinatura do que é exibido: detecta também troca de rota, ordem e
          // motoca feitas em outro terminal (não só mudança de quantidade).
          const assinatura = (l) =>
            l.map((p) => `${p.id}:${p.status}:${p.rota}:${p.ordem}:${p.entregador ? p.entregador.EntregadorId : 0}`).join('|');
          const pedidosChanged =
            assinatura(this.pedidosPendentes) !== assinatura(novo.grupos[0]) ||
            assinatura(this.pedidosACaminho) !== assinatura(novo.grupos[2]) ||
            assinatura(this.pedidosFinalizados) !== assinatura(novo.grupos[3]) ||
            assinatura(this.pedidosCancelados) !== assinatura(novo.grupos[4]);

          if (pedidosChanged || forceRefresh) {
            this.pedidosPendentes = novo.grupos[0];
            this.pedidosACaminho = novo.grupos[2];
            this.pedidosFinalizados = novo.grupos[3];
            this.pedidosCancelados = novo.grupos[4];
            this.pedidosSelecionados = novo.selecionados;
            this._atualizarPedidosMapaFlex();
            this.updateMap = true;
          } else if (entregadoresChanged) {
            this.updateMap = true;
          }
        })
      );
  }

  // Envia um "sync" de rota para /pedidos/definirstatus, tratando progresso e
  // recarregando os pedidos. [limpar] limpa a seleção ao final.
  _sincronizarRota(pedidos, limpar = false) {
    if (!pedidos || pedidos.length === 0) {
      return Promise.reject(new Error("Nenhum pedido informado"));
    }
    this.inProgress = true;

    return agent.Pedidos.definirStatus(pedidos)
      .then((res) => {
        if (res.CodigoRetorno === 1) {
          this.setError("");
          if (limpar) {
            this.pedidosSelecionados = [[], [], [], [], []];
            this.clearPedidoMarkers();
            this.originMarkerNeedsReset = true;
          }
          return null;
        }
        this.setError(res.Mensagem);
        throw res;
      })
      .finally(
        action(() => {
          this.buscarPedidos(true);
          this.inProgress = false;
        })
      );
  }

  // Cria uma nova rota com os pedidos SELECIONADOS (na ordem de clique), sem
  // alterar o Status. O número da rota = id do 1º pedido (mesma convenção do
  // backend). [entregadorId] opcional pré-atribui o motoca à rota.
  criarRotaComSelecionados(entregadorId = 0) {
    const sel = this.pedidosSelecionados[0];
    if (!sel || sel.length === 0) {
      return Promise.reject(new Error("Nenhum pedido selecionado"));
    }
    const numero = sel[0].id;
    const pedidos = sel.map((p, i) => {
      const m = { PedidoGuidId: p.guid, Rota: numero, Ordem: i + 1 };
      if (entregadorId) m.EntregadorId = entregadorId;
      return m;
    });
    return this._sincronizarRota(pedidos, true);
  }

  // Adiciona os pedidos SELECIONADOS ao final de uma rota existente. Herda o
  // motoca da rota (se houver).
  adicionarSelecionadosNaRota(rota) {
    const sel = this.pedidosSelecionados[0];
    if (!sel || sel.length === 0) {
      return Promise.reject(new Error("Nenhum pedido selecionado"));
    }
    const entId = rota.entregadorId;
    let ordem = rota.pedidos.length;
    const pedidos = sel.map((p) => {
      ordem++;
      const m = { PedidoGuidId: p.guid, Rota: rota.numero, Ordem: ordem };
      if (entId) m.EntregadorId = entId;
      return m;
    });
    return this._sincronizarRota(pedidos, true);
  }

  // Remove um pedido da rota (volta a avulso, sem motoca) e renumera o resto.
  removerPedidoDaRota(pedido) {
    const rota = this.rotas.find((r) => r.numero === pedido.rota);
    const restantes = rota
      ? rota.pedidos.filter((x) => x.id !== pedido.id)
      : [];
    const entId = rota ? rota.entregadorId : 0;

    const pedidos = [
      { PedidoGuidId: pedido.guid, Rota: 0, Ordem: 0, EntregadorId: 0 },
    ];
    restantes.forEach((p, i) => {
      const m = { PedidoGuidId: p.guid, Rota: pedido.rota, Ordem: i + 1 };
      if (entId) m.EntregadorId = entId;
      pedidos.push(m);
    });
    return this._sincronizarRota(pedidos);
  }

  // Move um pedido dentro da rota (delta = -1 sobe, +1 desce) e reenvia a rota
  // inteira com a nova ordem.
  moverPedidoNaRota(rota, index, delta) {
    const destino = index + delta;
    if (destino < 0 || destino >= rota.pedidos.length) {
      return Promise.resolve(null);
    }
    const lista = rota.pedidos.slice();
    const movido = lista.splice(index, 1)[0];
    lista.splice(destino, 0, movido);

    const entId = rota.entregadorId;
    const pedidos = lista.map((p, i) => {
      const m = { PedidoGuidId: p.guid, Rota: rota.numero, Ordem: i + 1 };
      if (entId) m.EntregadorId = entId;
      return m;
    });
    return this._sincronizarRota(pedidos);
  }

  // Define (ou troca) o motoca de uma rota inteira, SEM despachar (status
  // intacto). O pedido continua na aba Rotas até ser despachado.
  definirEntregadorRota(rota, entregadorId) {
    const pedidos = rota.pedidos.map((p, i) => ({
      PedidoGuidId: p.guid,
      Rota: rota.numero,
      Ordem: i + 1,
      EntregadorId: entregadorId,
    }));
    return this._sincronizarRota(pedidos);
  }

  // Desfaz a rota: tira todos os pedidos dela (voltam a avulsos, sem motoca).
  desfazerRota(rota) {
    const pedidos = rota.pedidos.map((p) => ({
      PedidoGuidId: p.guid,
      Rota: 0,
      Ordem: 0,
      EntregadorId: 0,
    }));
    return this._sincronizarRota(pedidos);
  }

  // Desenha no mapa a polyline de uma lista arbitrária de pedidos (botão
  // "Exibir" da aba Rotas). Também alimenta o link do Google Maps.
  calcularRotaPedidos(lista) {
    if (!this.mapAdapter || !lista || lista.length === 0) return;

    const comCoords = lista.filter((p) => p.lat && p.lng);
    if (comCoords.length === 0) return;

    this.setPedidosOrdenadosRota(comCoords);

    const origin =
      this.origemRestaurante.lat + "," + this.origemRestaurante.lng;
    const via = comCoords.map((p) => p.lat + "," + p.lng);

    this.mapAdapter.showRoute({ origin, destination: origin, via });
    this.updateMap = true;
  }

  // Despacha uma rota inteira para o motoca → A Caminho (status 2).
  despacharRota(rota, entregadorId, marcarACaminho = true) {
    return this._despacharPedidos(rota.pedidos, entregadorId, marcarACaminho);
  }

  // Despacha uma lista de pedidos (na ordem dada) para um entregador:
  // `definirentregador` + `definirstatus` A Caminho (2) ou Pendente (1).
  // O EntregadorId só vai no definirstatus(2) se o entregador estiver
  // disponível (igual ao fluxo do Definir Entregador).
  _despacharPedidos(lista, entregadorId, marcarACaminho) {
    if (!lista || lista.length === 0) {
      return Promise.reject(new Error("Nenhum pedido selecionado"));
    }
    this.inProgress = true;

    const vinculos = lista.map((p) => ({
      PedidoGuidId: p.guid,
      EntregadorId: entregadorId,
    }));

    return agent.Pedidos.definirEntregadores(vinculos)
      .then((res) => {
        if (res.CodigoRetorno !== 1) {
          this.setError(res.Mensagem);
          throw res;
        }

        const status = marcarACaminho ? 2 : 1;
        const entregador = this.entregadores.find((e) => e.id === entregadorId);
        const incluirEntregadorId =
          status === 2 &&
          isEntregadorDisponivel(
            entregador,
            this.pedidosPendentes,
            this.pedidosACaminho
          );

        const pedidosStatus = lista.map((p, i) => {
          const m = { PedidoGuidId: p.guid, Status: status, Ordem: i + 1 };
          if (incluirEntregadorId) m.EntregadorId = entregadorId;
          return m;
        });

        return agent.Pedidos.definirStatus(pedidosStatus);
      })
      .then((res) => {
        if (res.CodigoRetorno !== 1) {
          this.setError(res.Mensagem);
          throw res;
        }
        this.setError("");
        this.pedidosSelecionados = [[], [], [], [], []];
        this.clearPedidoMarkers();
        this.originMarkerNeedsReset = true;
        return null;
      })
      .finally(
        action(() => {
          this.buscarPedidos(true);
          this.inProgress = false;
        })
      );
  }

  // Fluxo principal do "Definir Entregador" (espelha o enviarParaEntregador do
  // Flutter): despacha os pedidos SELECIONADOS (pendentes) para o entregador,
  // marcando A Caminho (2) ou Pendente (1). Usa o despacho SEQUENCIAL
  // (definirentregador -> definirstatus, 1 request cada, 1 refresh) — igual ao
  // app Flutter, em vez de disparar dois requests soltos.
  enviarParaEntregador(entregadorId, marcarACaminho) {
    return this._despacharPedidos(
      this.pedidosSelecionados[0],
      entregadorId,
      marcarACaminho
    );
  }

  // ----------------- Modo flexível (ModoDistribuicao=1) -----------------

  // Remove o motoca dos pedidos SELECIONADOS (A Caminho) e os devolve para
  // Pendentes (avulsos, sem rota). Só faz sentido no modo flexível.
  // 1 request: desvincula o motoca (EntregadorId:0), volta pra "Pronto"
  // (Status:1) e limpa a rota (Rota:0/Ordem:0), tudo numa transação.
  removerEntregadorDosSelecionados() {
    const sel = this.pedidosSelecionados[this.tabIndex];
    if (!sel || sel.length === 0) {
      return Promise.reject(new Error("Nenhum pedido selecionado"));
    }
    const pedidos = sel.map((p) => ({
      PedidoGuidId: p.guid,
      Status: 1,
      EntregadorId: 0,
      Rota: 0,
      Ordem: 0,
    }));
    return this._sincronizarRota(pedidos, true);
  }

  // true se o entregador está atualmente com pedidos A Caminho (em rota).
  entregadorEmRota(entregadorId) {
    return this.pedidosACaminho.some(
      (p) => p.entregador && p.entregador.EntregadorId === entregadorId
    );
  }

  // Adiciona os pedidos SELECIONADOS a um motoca que JÁ está a caminho: eles
  // entram no FIM da rota dele (última ordem) e já saem A Caminho (Status 2).
  // Só permitido no modo flexível.
  adicionarSelecionadosAEntregadorEmRota(entregadorId) {
    const sel = this.pedidosSelecionados[this.tabIndex];
    if (!sel || sel.length === 0) {
      return Promise.reject(new Error("Nenhum pedido selecionado"));
    }

    const doMotoca = this.pedidosACaminho
      .filter((p) => p.entregador && p.entregador.EntregadorId === entregadorId)
      .slice()
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));

    if (doMotoca.length === 0) {
      // Não está em rota: cai no fluxo normal de despacho.
      return this._despacharPedidos(sel, entregadorId, true);
    }

    const ultimo = doMotoca[doMotoca.length - 1];
    const maxOrdem = ultimo.ordem || 0;
    const rotaMotoca = ultimo.rota !== 0 ? ultimo.rota : doMotoca[0].id;

    const pedidos = sel.map((p, i) => ({
      PedidoGuidId: p.guid,
      Status: 2,
      EntregadorId: entregadorId,
      Rota: rotaMotoca,
      Ordem: maxOrdem + i + 1,
    }));
    return this._sincronizarRota(pedidos, true);
  }

  rebuildStore(){
    console.log('rebuilding mapa store')
    this.inProgress = false;

    this.updateMap = false;

    this.error = "";

    this.filtro = "";

    this.pedidosMapa = [];

    this.pedidosPendentes = [];

    this.pedidosACaminho = [];

    this.pedidosFinalizados = [];

    this.pedidosCancelados = [];

    this.pedidosSelecionados = [[], [], [], [], []];

    this.pedidosHistorico = [];

    this.pedidosOrdenadosRota = [];

    this.entregadores = [];


    this.mapAdapter = null;

    this.tabIndex = 0;

    this.ordemDoFiltro = false;

    this.linkRota = "";

    this.originMarkerNeedsReset = false;
  }
}


export default new MapaStore();
